import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import {
  BarAutoAdBannerContainer,
  BottomRelatedRecommendListContainer,
  BrandLiabilityCompensationBannerContainer,
  DescriptionTopBannerContainer,
  ExclusiveBannerContainer,
  FistOrderBannerContainer,
  InfiniteRecommendContainer,
  LegacyModelSizeContainer,
  LegacySizeRecommendationSectionContainer,
  MetaStylePdpLinkContainer,
  OverseaDirectBannerContainer,
  OverseaProductInfoContainer,
  PolicyResponsibilityContainer,
  ProductDescriptionContainer,
  ProductInfoProvidedNoticeContainer,
  RelatedStylistListContainer,
  SellerNoticeContainer,
  ShortClipContainer,
  SizeRecommendTooltipContainer,
  StoreDealGuideBannerContainer,
  useSizeTabABT,
  useTabDescriptionService,
  useTabsService,
} from '@domains/pdp-features';

export const TabProductDescriptionScreen: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { isControlGroup } = useSizeTabABT();
  const tabService = useTabsService();
  const tabDescriptionService = useTabDescriptionService({ sizeRecommendRef: tabService.sizeRecommendRef });
  return (
    <>
      <div ref={tabDescriptionService.wrapperRef}>
        <ExclusiveBannerContainer />
        <DescriptionTopBannerContainer />
        <MetaStylePdpLinkContainer />
        <FistOrderBannerContainer />
        <StoreDealGuideBannerContainer />
        <BrandLiabilityCompensationBannerContainer />
        <OverseaDirectBannerContainer />
        <OverseaProductInfoContainer />
        <SellerNoticeContainer />
        <ShortClipContainer />
        <ProductDescriptionContainer
          isDescriptionOpened={tabDescriptionService.isDescriptionOpened}
          setIsDescriptionOpened={tabDescriptionService.setIsDescriptionOpened}
          intersectionObserverCallback={tabDescriptionService.intersectionObserverCallback}
          options={{ rootMargin: '0px 0px -450px 0px' }}
        />
        {/* ABT Control 그룹: 상품설명 탭에 SizeRecommendTooltip 노출 */}
        {isControlGroup && (
          <SizeRecommendTooltipContainer
            sizeRecommendRef={tabService.sizeRecommendRef}
            wrapperRect={tabDescriptionService.wrapperRect}
            isDescriptionOpened={tabDescriptionService.isDescriptionOpened}
          />
        )}
      </div>
      {/* ABT Control 그룹: 상품설명 탭에 ModelSize, SizeRecommendation 노출 */}
      {isControlGroup && (
        <>
          <LegacyModelSizeContainer />
          <LegacySizeRecommendationSectionContainer onSizeRecommendRefChange={tabService.onSizeRecommendRefChange} />
        </>
      )}

      {tabDescriptionService.isBeautyCategory && (
        <>
          <Divider />
          <ProductInfoProvidedNoticeContainer />
        </>
      )}

      <BarAutoAdBannerContainer banner_index={0} position='top' />

      <RelatedStylistListContainer className='related-stylist-list' />

      {tabService.isInfiniteRecommend ? (
        <>
          <BottomRelatedRecommendListContainer
            productId={tabService.product.id}
            isInfiniteRecommend={tabService.isInfiniteRecommend}
          />
          <InfiniteRecommendContainer
            className='infinite-recommend-list'
            isBrand={tabService.product.is_brand}
            isAdBannerEnabled={!tabService.isSelectedShop}
          />
        </>
      ) : (
        <>
          <BottomRelatedRecommendListContainer productId={tabService.product.id} />
          <BarAutoAdBannerContainer banner_index={1} position='bottom' />
        </>
      )}
      <PolicyResponsibilityContainer />
    </>
  );
};

const Divider = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${vars.v3Color.gray100};
`;
